'use client';

import React from 'react';
import { Button } from "@/components/ui/button";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Bevestigen",
  cancelText = "Annuleren"
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg max-w-md w-full">
        <div className="p-6">
          <h2 className="text-xl font-bold mb-4">{title}</h2>
          <p 
            className="mb-6"
            dangerouslySetInnerHTML={{ __html: message }}
          ></p>
          
          <div className="flex justify-end space-x-4">
            <Button 
              variant="outline" 
              type="button"
              onClick={onClose}
              className="font-medium"
            >
              {cancelText}
            </Button>
            <Button 
              type="button"
              onClick={() => {
                onConfirm();
                onClose();
              }}
              variant="green"
              className="font-bold"
            >
              {confirmText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
